






























































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop, Watch} from "vue-property-decorator";
import ShiftEmployeeForm from "@/modules/shift/components/ShiftEmployeeForm/index.vue";
import {ShiftStore} from "@/modules/shift/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ShiftEmployeeParams} from "@/modules/shift/params";
import debounce from 'lodash/debounce';
import LadingDebit from "@/modules/shift/components/LadingDebit/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 10
    },
    {
        title: 'Thao tác',
        dataIndex: 'employee',
        key: 'action',
        scopedSlots: { customRender: "action" },
        width: 20
    },
    {
        title: 'Số điện thoại',
        dataIndex: 'employee',
        key: 'phoneNumber',
        scopedSlots: { customRender: "phoneNumber" },
        width: 80
    },
    {
        title: 'Họ tên',
        dataIndex: 'employee',
        key: 'name',
        scopedSlots: { customRender: "name" },
        width: 80
    }
]

@Component({
    name: "ShiftEmployee",
    components: {LadingDebit, ShiftEmployeeForm}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly shiftId!: number;
    params = new ShiftEmployeeParams();
    columns = [...columns];
    visibleForm = false;
    visibleDebit = false;
    employeeRowGuidDebit = "";

    created() {
        ShiftStore.updateParamsShiftEmployee(new ShiftEmployeeParams());
        ShiftStore.listEmployeeInShift({ shiftId: this.shiftId, params: ShiftStore.paramsEmployee });
        ShiftStore.singleShift(this.shiftId);
    }

    get shiftEmployees() {
        return ShiftStore.idsEmployee.map((id: number) => ShiftStore.dataEmployee[id]);
    }

    get shift() {
        return ShiftStore.data[this.shiftId];
    }

    get pagination() {
        return {
            current: ShiftStore.metaEmployee.page,
            pageSize: ShiftStore.metaEmployee.limit,
            total: ShiftStore.metaEmployee.total,
            showTotal: (total: number) => `Tổng cộng ${total} nhân viên`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onchangePage(pagination: any) {
        ShiftStore.updateParamsShiftEmployee({
            ...ShiftStore.paramsEmployee,
            page: pagination.current
        });
        ShiftStore.listEmployeeInShift({ shiftId: this.shiftId, params: ShiftStore.paramsEmployee });
    }

    @Watch("params.search")
    onchangeSearch(val: any) {
        this.handleSearch(val);
    }

    handleSearch = debounce((val: any) => {
        ShiftStore.updateParamsShiftEmployee({
            ...ShiftStore.paramsEmployee,
            page: 1,
            search: val
        });
        ShiftStore.listEmployeeInShift({ shiftId: this.shiftId, params: ShiftStore.paramsEmployee });
    }, 500)

    async onConfirm(employeeRowGuid: string) {
        if (!this.hasPermissionAddAndRemoveEmployee()) return;
        try {
            await ShiftStore.removeEmployeeFromShift({
                shiftId: this.shiftId,
                employeeRowGuid
            });
            this.$message.success("Xóa nhân viên thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa nhân viên ca thất bại');
        }
    }

    seeDebit(rowGuid: string) {
        this.employeeRowGuidDebit = rowGuid;
        this.visibleDebit = true;
    }

    addEmployee() {
        if (!this.hasPermissionAddAndRemoveEmployee()) return;
        this.visibleForm = true;
    }

    hasPermissionAddAndRemoveEmployee() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_CREATE_SHIFT) && !this.hasPermission(RoleDeclare.ROLE_CAN_EDIT_SHIFT)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return false;
        }
        return true;
    }
}
